/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactSiegeSocialGridDto } from './ContactSiegeSocialGridDto';
import {
    ContactSiegeSocialGridDtoFromJSON,
    ContactSiegeSocialGridDtoFromJSONTyped,
    ContactSiegeSocialGridDtoToJSON,
} from './ContactSiegeSocialGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContactSiegeSocialGridDtoPaginatedResults
 */
export interface ContactSiegeSocialGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeSocialGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContactSiegeSocialGridDto>}
     * @memberof ContactSiegeSocialGridDtoPaginatedResults
     */
    results?: Array<ContactSiegeSocialGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContactSiegeSocialGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContactSiegeSocialGridDtoPaginatedResults interface.
 */
export function instanceOfContactSiegeSocialGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactSiegeSocialGridDtoPaginatedResultsFromJSON(json: any): ContactSiegeSocialGridDtoPaginatedResults {
    return ContactSiegeSocialGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContactSiegeSocialGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactSiegeSocialGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContactSiegeSocialGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContactSiegeSocialGridDtoPaginatedResultsToJSON(value?: ContactSiegeSocialGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContactSiegeSocialGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

